import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  animate?: boolean;
}

export const Logo = ({ className, animate = false }: LogoProps) => {
  return (
    <div 
      className={cn(
      'flex items-center justify-center',
      animate && 'animate-scale-in',
      className
    )}>
      <img 
        src="/siimply-logo-v2.png" 
        alt="SiimplyTrade Logo" 
        className="h-48 w-auto object-contain"
      />
    </div>
  );
};
